<template>
  <div class="policy">
    <div class="tracking-wider border borderColordarkgray2 rounded overflow-hidden px-4 md:px-8 py-6 md:py-8 leading-loose">
      <div class="service">
        <h3 class="text-NotoSansBold text-base lg:text-lg title mb-3 lg:mb-5 px-2 md:text-center">「希伯崙股份有限公司」所屬網站(LiveABC互動英語教學集團)會員服務條款</h3>

        <div class="privacy-body text-NotoSansRegular text-sm">
          <h5>一、認知與接受條款</h5>
          <ul class="list-decimal list-inside mt-6 mb-12">
            <li>「希伯崙股份有限公司」(以下稱本公司)所經營之網站「LiveABC互動英語教學集團」網站(以下稱LiveABC網站)，將依據本會員服務條款（以下稱本服務）提供LiveABC網站各項服務內容。當您完成LiveABC互動英教學集團會員註冊手續、或開始使用本服務時，即表示您已閱讀、瞭解並同意接受本服務條款之所有内容。並完全接受本服務現有與未來衍生的服務項目及內容。本公司有權於任何時間修改或變更本服務條款之內容，修改後的服務條款內容將於公告三十日內公佈於LiveABC互動英語教學集團網站，並於使用服務時通知個別會員。如會員於任何修改或變更後，並同意繼續使用本服務者，將視為會員己閱讀、瞭解並同意接受該等修改或變更。若您不同意上述的服務條款修訂或更新方式，或您所屬的國家或地域排除本會員服務條款內容之全部或一部份，或不接受本服務條款的任一約定時，您可立即停止使用本服務。</li>
            <li>若您為未滿十八歲，除應收受上述條款外，應確認您的法定代理人閱讀、瞭解並同意本會員服務條款之所有内容及其後修改變更後，方得使用或繼使用本服務。當您使用或繼續使用本服務時，需取得請未成年人提供法代同意書或由以專人電話回撥確認身分確認，即表示您的法定代理人已閱讀、瞭解並同意接受本會員服務條款之所有內容及其後修改變更。</li>
            <li>於提供網路購物、行銷推廣、物流服務、帳務服務、客戶管理及服務，本公司將藉由加入會員或進行交易之手續，蒐集、處理、及利用您的個人資料，包括姓名、性別、生日、教育、職業、地址、e-mail、聯絡方式、信用卡號、Android廣告ID等，並對您發送活動訊息、商品優惠訊息、廣告等相關服務。為了確保會員之個人資料、隱私及消費者權益之保護，依個人資料保護法規定告知以下事項，本公司將以電郵、傳真、電話、簡訊或其他通知公告方式利用您所提供之資料（資料類別C001、C002、C003、C011等各項類別相關資料）。</li>
            <li>除會員有反對之表示，LiveABC集團網站得於會員入會期間內，利用會員之個人資料。LiveABC集團網站對所蒐集之資料依法保密。會員有請求停止蒐集、處理、利用或請求刪除之權利，辦理方式為電話通知客服中心處理(02)2578-7838。</li>
            <li>您同意於下列情形發生時，得依法公開您的個人資訊：
              <ul class="list-disc list-inside ml-4 child-ul">
                <li>法律明文規定。</li>
                <li>為維護國家安全或增進公共利益所必要。</li>
                <li>為免除當事人之生命、身體、自由或財產上之危險。</li>
                <li>為防止他人權益之重大危害。</li>
              </ul>
            </li>
            <li>您得自由選擇提供之個人資料，若您提供之資料不正確、不完整或未隨時更正或補充，可能會無法收到刊物、最新優惠訊息等。</li>
            <li>會員有權對個人資料行使以下權利，包含查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、請求刪除，如欲行使上述權利，可與本公司客服連絡進行申請。</li>

          </ul>

          <h5>二、會員遵守（注意）事項</h5>
          <p class="text-red-600 mt-6">您註冊為會員或於使用本服務之同時，會員將遵守以下義務：</p>
          <ul class="list-decimal list-inside mt-6 mb-12">
            <li>於本服務註冊表詢問事項，提供您本人正確、最新及完整的資料，且不得以第三人名義註冊為會員。每位會員僅能註冊及登錄一個帳號，不可重覆註冊及登錄。</li>
            <li>為確保會員個人資料為正確、最新及完整，會員應維持並即時更新個人資料。</li>
            <li>若會員有提供任何錯誤或不實資料、或未按指示提供資料、或欠缺必要資料、或有重覆註冊帳號等情事時，經本公司確認屬實後，應通知會員立即修正資料，以確保會員使用權益。</li>
            <li>會員須妥善保存自己的帳號及密碼，不得將密碼告訴第三者，甚或提供第三者使用。<br/>會員的帳號、密碼及會員權益均僅供會員個人使用及享有，在任何情形下，不得以任何形式轉借、轉讓本服務予他人或與他人合用。</li>
            <li>雙方當事人之任何一方，發現會員之使用者帳號或個人密碼遭第三人不法或不當之使用者，應立即通知對方。經會員確認有遭第三人不法或不當之使用情事者，本公司將立即暫停該使用者帳號或個人密碼之使用，並接受會員更換其使用者帳號或個人密碼。</li>
          </ul>

          <h5>三、隱私權聲明</h5>
          <p class="mt-6 mb-12">會員資料依本公司「隱私權聲明」受到保護及規範，請參閱&ensp;
            <router-link :to="{ name: 'privacy' }" class="font-bold">隱私權政策</router-link>
          </p>

          <h5>四、廣宣及電子報、EDM發送</h5>
          <p class="mt-6 mb-12">會員同意本公司基於行銷目的，於會員註冊有效期間內，得不定期發送廣告印刷品、電子報或EDM至會員所登錄的地址或電子信箱帳號。當會員收到訊息後，如表示拒絕接受行銷時，本公司將停止繼續發送行銷訊息。</p>

          <h5>五、免責聲明</h5>
          <ul class="list-decimal list-inside mt-6 mb-12">
            <li>有關本公司所提供之各項會員或使用者服務，均以該服務具有可合理期待安全性之服務，以及當時之功能及現況提供使用，會員使用本服務時，因可歸責於第三人之事由，發生教學內容錯誤、網站系統畫面暫停、中斷、不能進行連線或其他服務品質瑕疵之情形，消費者得準用第二項各款之約定，請求本公司於七個工作日內補償之。</li>
            <li>會員使用本服務進行交易時，應依據本公司確認後之商品數量及價格機制進行，若本服務網站上所標售商品或服務，發生交易條件(包括但不限於價格、規格、內容說明、圖片)錯誤時，本公司仍得於下單後三工作日內拒絕該筆訂單。</li>
          </ul>

          <h5>六、第三方網站連結免責條款</h5>
          <p class="mt-6 mb-12">會員可能會於LiveABC網站中連結至其他業者(下稱第三方)經營的網站，但不表示本公司與該第三方有任何關係。第三方經營的網站均由該業者自行負責，不屬本公司控制及負責範圍內。對於會員經由LiveABC網站連結或瀏覽之其他網站內容，會員應於連結前自行斟酌與判斷該網站內容之合適性、有效性、正確性、完整性、及是否侵害他人權利，以免遭受損失，本公司對於該等損失不負任何賠償責任，如檢索到一些令會員厭惡或不需要的網站，遇到此類情形時，本公司建議會員不要瀏覽或儘速離開該等網站。本服務隨時可能與第三方合作，由其提供包括新聞、訊息、活動等不同內容供本服務刊登，且本服務於刊登時均將註明內容來源。基於尊重第三方之智慧財產權，本服務對其所提供之內容並不做實質之審查或修改。對該等內容之正確真偽，會員宜自行判斷之，本公司對該等內容之正確真偽不負任何責任。會員若認為某些內容屬不適宜、侵權或有所不實，請逕向該第三方反應意見。</p>

          <h5>七、服務中斷或故障</h5>
          <p class="mt-6 mb-12">本服務有時可能會出現中斷或故障等現象，或是服務設備進行必要之保養及施工時需暫時停止服務；如遇需暫停服務，將於暫停服務時間提前公告，並以電子郵件或網站介面公告通知消費者。</p>

          <h5>八、會員使用限制規範</h5>
          <p class="text-red-600 mt-6">會員同意不將「本服務」作以下用途：</p>
          <ul class="list-decimal list-inside mt-6 mb-12">
            <li>干擾或破壞「本服務」或與「本服務」相連線之伺服器和網路，或不遵守於本服務連線網路之規定或規範。</li>
            <li>公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案於本服務上。</li>
            <li>侵害他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利。</li>
            <li>違反依法律或契約所應負之保密義務。</li>
            <li>冒用他人名義使用本服務。</li>
            <li>傳輸或散佈電腦病毒。</li>
            <li>從事不法或未經本公司授權之商業或廣告宣傳行為。</li>
            <li>其他本公司認為不適當之行為。</li>
          </ul>

          <h5>九、智慧財產權保護</h5>
          <p class="mt-6 mb-12">本服務所使用之軟體或程式、網站上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、網站畫面的安排、網頁設計，均由本公司或其他權利人依法擁有其智慧財產權，並已為消費者取得本契約利用範圍內之充分授權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。任何人不得逕自使用、修改、重製、公開播送、改作、散布、發行、公開發表、進行還原工程、解編或反向組譯。若會員欲引用或轉載前述軟體、程式或網站內容，除明確為法律所允許者外，必須依法取得本公司或其他權利人的事前書面同意。尊重智慧財產權是您應盡的義務，如有違反，會員應對本公司負損害賠償責任，包括但不限於訴訟費用及律師費用等。</p>

          <h5>十、會員責任風險告知</h5>
          <p class="my-6">由會員公開張貼或私下傳送的資訊、資料、文字、軟體、音樂、音訊、照片、圖形、視訊、信息或其他資料（以下稱「會員內容」），均由提供者自負責任。本公司不保證「會員內容」其正確性、完整性或品質。您了解使用本服務時，可能會接觸到令人不快、不適當、令人厭惡之「會員內容」。在任何情況下，本公司均不為任何「會員內容」負責，包含但不限於任何錯誤或遺漏，以及經由本服務張貼、發送電子郵件或傳送而衍生之任何損失或損害。</p>
          <p>會員了解本公司並未針對「會員內容」事先加以審查，但本公司有權（但無義務）針對「會員內容」之實際內容，加以審核。在不限制前開規定之前提下，本公司及其指定人有權將違反本服務條款和令人厭惡之任何「會員內容」加以移除。會員使用任何「會員內容」時，就前開「會員內容」之正確性、完整性或實用性之情形，會員同意必須自行加以評估並承擔所有風險。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Policy',
  metaInfo () {
    return {
      title: '服務條款',
      titleTemplate: null
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    li {
      margin-bottom: 1rem;
      .child-ul {
        list-style-type: cjk-ideographic;
        li {
          margin-bottom: 0rem;
        }
      }
    }
  }
</style>
